import { render, staticRenderFns } from "./PreviewAndEditImage.vue?vue&type=template&id=647df736&"
import script from "./PreviewAndEditImage.vue?vue&type=script&lang=js&"
export * from "./PreviewAndEditImage.vue?vue&type=script&lang=js&"
import style0 from "./PreviewAndEditImage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports